<script setup>
import { RouterLink } from "vue-router";
import { BRAND_LOGO_URL } from "@/shared/config/constants";
</script>

<template>
  <footer class="app-footer">
    <img :src="BRAND_LOGO_URL" alt="" />
    <span>学 AI，做中学！</span>
    <RouterLink :to="{ name: 'about' }">about</RouterLink>
    <RouterLink :to="{ name: 'about-v2' }">about v2</RouterLink>
  </footer>
</template>
